export default "__VITE_ASSET__7522b54e__"